(function () {
  'use strict';

  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var params = new URLSearchParams(window.location.search);
  var values = {};

  keys.forEach(function (key) {
    var current = params.get(key);
    if (current) {
      values[key] = current.slice(0, 512);
      try { window.sessionStorage.setItem('ss_' + key, values[key]); } catch (error) {}
    } else {
      try { values[key] = window.sessionStorage.getItem('ss_' + key) || ''; } catch (error) { values[key] = ''; }
    }
  });

  function populate(form) {
    if (!(form instanceof HTMLFormElement)) return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact') return;

    keys.forEach(function (key) {
      if (!values[key]) return;
      var name = 'contact[' + key + ']';
      var field = Array.prototype.find.call(form.querySelectorAll('input[name]'), function (input) {
        return input.name === name;
      });
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        form.appendChild(field);
      }
      field.value = values[key];
    });
  }

  function populateAll(root) {
    if (root instanceof HTMLFormElement) populate(root);
    root.querySelectorAll('form').forEach(populate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { populateAll(document); });
  } else {
    populateAll(document);
  }

  document.addEventListener('submit', function (event) { populate(event.target); }, true);
  document.addEventListener('shopify:section:load', function (event) { populateAll(event.target); });
})();
